// extracted by mini-css-extract-plugin
export default {"root":"hCjcHvABBTpgII08sbM9"};